/**
 * Created by ganlu on 24/03/2017.
 */
export default () => {
    return function (scope, elem) {
        elem.on('click', '.nav', (e) => {

            if($(e.target).hasClass('coming-soon'))
            {
                return;
            }

            elem.removeClass('active');
            $('.mobile-side-nav-mask').removeClass('active');
            $('body').removeClass('no-scroll');
        });
    };
};



// WEBPACK FOOTER //
// ./src/app/components/face/face-header/side-nav-control.directive.js